import React, { useEffect, useState,useCallback } from 'react';
import styled from 'styled-components';
import api from '../../../utils/api';
import {ActionButton,IconButton} from '../common/AdminButtons';
import {Table,Tr,Td,Th} from '../common/AdminTable';
import {H1} from '../common/AdminHeadings';
import { ErrorMessage,LoadingMessage } from '../common/AdminMessages';
import {Modal} from '../../Modal';
import JargonForm from './JargonForm';
import Jargon from '../../../models/Jargon';

const ListContainer = styled.div`
    padding:20px;
`;

const JargonList: React.FC = () => {
    const [jargons, setJargons] = useState<Jargon[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string>('');
    const [isModalOpen,setIsModalOpen] = useState(false);
    const[selectedJargon,setSelectedJargon] = useState<Jargon | undefined>(undefined);
  
    const closeModal =() =>
    {
        setIsModalOpen(false);
    }
    const onModalSuccess = ()=>
    {
        setIsModalOpen(false);
        setLoading(true);
        fetchJargons();
    }

    const editJargon = useCallback((id:number) =>{
        setSelectedJargon(jargons.find(item=>item.id===id));
        setIsModalOpen(true);
    },[jargons]);
    const addJargon = () =>{
        setSelectedJargon(undefined);
        setIsModalOpen(true);
    }
    //example of useCallback -- prevents a bunch of copies of functions from being created in lists
    const deleteJargon = useCallback(async(id:number,name:string) =>{
        if(window.confirm(`Are you sure you want to delete the ${name} Jargon from existence? Please consider which coworkers may be cross with you.`))
        {
          let response = await api.delete(`/halo/jargons/${id}`);
          if(response.status / 100 == 2)
          {
            fetchJargons();
          }
        }        
    },
    [])
    ;
  
    useEffect(() => {
      fetchJargons();
    }, []);
  
    const fetchJargons = async () => {
      try {
        const response = await api.get('/halo/jargons/');
        setJargons(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch jargons');
        setLoading(false);
      }
    };

    const renderContent = () => {
        if (loading) {
          return <LoadingMessage>Loading jargons...</LoadingMessage>;
        }
    
        if (error) {
          return <ErrorMessage>{error}</ErrorMessage>;
        }
    
        return (
            <>
            <ActionButton onClick={addJargon}>Add Jargon</ActionButton>
            <Table>
                <thead>
                <Tr>
                    <Th>Edit</Th>
                    <Th>Display?</Th>
                    <Th>Name</Th>
                    <Th>Description</Th>
                </Tr>
                </thead>
                <tbody>
                {jargons.map(jargon => (
                    <Tr key={jargon.id}>
                    <Td>
                      <IconButton onClick={()=>{editJargon(jargon.id);}}><i className="fa-sharp fa-solid fa-pen-to-square"></i></IconButton>
                      <IconButton onClick={()=>{deleteJargon(jargon.id,jargon.name);}}><i className="fa-sharp fa-solid fa-trash"></i></IconButton>
                      <a href={`/halo/jargons/${jargon.id}/words`}><IconButton><i className="fa-sharp fa-solid fa-book"></i></IconButton></a>
                    </Td>
                    <Td>{jargon.publicDisplay && <i className="fa-sharp fa-solid fa-check"></i>}</Td>
                    <Td>{jargon.name}</Td>                    
                    <Td>{jargon.description}</Td>
                    </Tr>
                ))}
                </tbody>
            </Table>
            </>
        );
      };
    return(
        <ListContainer>
            <H1>Jargons</H1>
            {renderContent()}
            <Modal isOpen={isModalOpen} onClose={closeModal}>
              <JargonForm onCancel={closeModal} onSuccess={onModalSuccess} initialJargon={selectedJargon}></JargonForm>
            </Modal> 
        </ListContainer>
    );
};
export default JargonList;